const icons = {
  country: '/static/country.png',
  dealType: '/static/dealType.png',
  price: '/static/price.png',
  resultType: '/static/resultType.png',
  time: '/static/time.png',
  fbzt: '/static/fbzt.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '产业分类',
    prop: 'industrialType',
    icon: icons.dealType,
    tagList: [
      { name: '新一代信息技术产业', value: '1' },
      { name: '高端装备制造产业', value: '2' },
      { name: '新材料产业', value: '3' },
      { name: '生物产业', value: '4' },
      { name: '新能源汽车产业', value: '5' },
      { name: '新能源产业', value: '6' },
      { name: '节能环保产业', value: '7' },
      { name: '数字创意产业', value: '8' },
      { name: '相关服务业', value: '9' }
    ]
  },
  {
    ...publicOptions,
    name: '区域',
    prop: 'address',
    icon: icons.country,
    tagList: [
      { name: '北京', value: '北京', key: 'cn' },
      { name: '上海', value: '上海', key: 'at' },
      { name: '天津', value: '天津', key: 'at' },
      { name: '重庆', value: '重庆', key: 'us' },
      { name: '江苏', value: '江苏', key: 'gb' },
      { name: '广东', value: '广东', key: 'de' },
      { name: '山东', value: '山东', key: 'jp' },
      { name: '浙江', value: '浙江', key: 'jp' },
      { name: '四川', value: '四川', key: 'jp' },
      { name: '河北', value: '河北', key: 'jp' },
      { name: '湖北', value: '湖北', key: 'jp' },
      { name: '福建', value: '福建', key: 'jp' },
      { name: '辽宁', value: '辽宁', key: 'jp' },
      { name: '河南', value: '河南', key: 'jp' },
      { name: '安徽', value: '安徽', key: 'jp' },
      { name: '湖南', value: '湖南', key: 'jp' },
      { name: '陕西', value: '陕西', key: 'jp' },
      { name: '广西', value: '广西', key: 'jp' },
      { name: '江西', value: '江西', key: 'jp' },
      { name: '山西', value: '山西', key: 'jp' },
      { name: '黑龙江', value: '黑龙江', key: 'jp' },
      { name: '吉林', value: '吉林', key: 'jp' },
      { name: '贵州', value: '贵州', key: 'jp' },
      { name: '云南', value: '云南', key: 'jp' },
      { name: '新疆', value: '新疆', key: 'jp' },
      { name: '甘肃', value: '甘肃', key: 'jp' },
      { name: '内蒙古', value: '内蒙古', key: 'jp' },
      { name: '海南', value: '海南', key: 'jp' },
      { name: '宁夏', value: '宁夏', key: 'jp' },
      { name: '青海', value: '青海', key: 'jp' },
      { name: '西藏', value: '西藏', key: 'jp' }
      // { name: '其他地区', value: '其他地区', key: '其他地区' }
    ]
  }
]

module.exports = {
  filterOptions
}
